import React from 'react';
import Icon from '../../../components/AppIcon';

const StepIndicator = ({ currentStep, totalSteps }) => {
  const steps = [
    {
      id: 1,
      title: 'Platform',
      description: 'Choose source platform',
      icon: 'Layers'
    },
    {
      id: 2,
      title: 'Source',
      description: 'Select playlists to sync',
      icon: 'List'
    },
    {
      id: 3,
      title: 'Destination',
      description: 'Choose destination',
      icon: 'Target'
    }
  ];

  return (
    <div className="w-full">
      {/* Mobile Progress Bar */}
      <div className="lg:hidden mb-6">
        <div className="flex items-center justify-between mb-3">
          <h2 className="text-sm font-medium text-text-primary">
            Step {currentStep} of {totalSteps}
          </h2>
          <span className="text-xs text-text-secondary">
            {Math.round((currentStep / totalSteps) * 100)}% Complete
          </span>
        </div>
        
        <div className="flex items-center space-x-2 mb-2">
          <Icon 
            name={steps[currentStep - 1]?.icon} 
            size={16} 
            className="text-primary" 
          />
          <span className="text-sm font-medium text-text-primary">
            {steps[currentStep - 1]?.title}
          </span>
        </div>
        
        <div className="w-full bg-surface-secondary rounded-full h-2">
          <div 
            className="bg-primary h-2 rounded-full transition-all duration-300 ease-out"
            style={{ width: `${(currentStep / totalSteps) * 100}%` }}
          ></div>
        </div>
        
        <p className="text-xs text-text-muted mt-2">
          {steps[currentStep - 1]?.description}
        </p>
      </div>

      {/* Desktop Step Indicator */}
      <div className="hidden lg:block mb-8">
        <div className="flex items-center justify-between">
          {steps.map((step, index) => {
            const isActive = index + 1 === currentStep;
            const isCompleted = index + 1 < currentStep;
            const isUpcoming = index + 1 > currentStep;

            return (
              <div key={step.id} className="flex items-center">
                {/* Step Circle */}
                <div className="flex items-center">
                  <div
                    className={`flex items-center justify-center w-10 h-10 rounded-full border-2 transition-all duration-300 ${
                      isCompleted
                        ? 'bg-success border-success text-success-foreground'
                        : isActive
                        ? 'bg-primary border-primary text-primary-foreground'
                        : 'bg-surface border-border text-text-secondary'
                    }`}
                  >
                    {isCompleted ? (
                      <Icon name="Check" size={20} />
                    ) : (
                      <Icon name={step.icon} size={20} />
                    )}
                  </div>
                  
                  {/* Step Info */}
                  <div className="ml-4">
                    <div
                      className={`text-sm font-medium transition-colors duration-200 ${
                        isActive
                          ? 'text-primary'
                          : isCompleted
                          ? 'text-success' :'text-text-secondary'
                      }`}
                    >
                      {step.title}
                    </div>
                    <div className="text-xs text-text-muted mt-1">
                      {step.description}
                    </div>
                  </div>
                </div>

                {/* Connector Line */}
                {index < steps.length - 1 && (
                  <div className="flex-1 mx-8">
                    <div
                      className={`h-0.5 transition-colors duration-300 ${
                        index + 1 < currentStep ? 'bg-success' : 'bg-border'
                      }`}
                    ></div>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* Progress Bar */}
        <div className="mt-6">
          <div className="flex items-center justify-between text-xs text-text-muted mb-2">
            <span>Setup Progress</span>
            <span>{Math.round((currentStep / totalSteps) * 100)}% Complete</span>
          </div>
          <div className="w-full bg-surface-secondary rounded-full h-1">
            <div 
              className="bg-primary h-1 rounded-full transition-all duration-500 ease-out"
              style={{ width: `${(currentStep / totalSteps) * 100}%` }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepIndicator;